var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalReferringdomains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_4357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9049 37.1617C24.0334 37.1617 21.4145 36.0606 19.4474 34.2589C17.327 36.2495 16 39.0762 16 42.2072V43.6721H37.8099V42.2072C37.8099 39.0762 36.483 36.2495 34.3625 34.2588C32.3954 36.0605 29.7765 37.1617 26.9049 37.1617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9052 34.2317C31.3908 34.2317 35.0271 30.5954 35.0271 26.1098C35.0271 21.6241 31.3908 17.9878 26.9052 17.9878C22.4195 17.9878 18.7832 21.6241 18.7832 26.1098C18.7832 30.5954 22.4195 34.2317 26.9052 34.2317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1504 50.9771C57.8226 52.8802 54.8505 54.0235 51.6161 54.0235C48.3817 54.0235 45.4098 52.8802 43.0818 50.9771C39.5361 53.5992 37.2324 57.8093 37.2324 62.5478V64.0126H65.9998V62.5478C65.9998 57.8093 63.6961 53.5991 60.1504 50.9771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0862 47.9967C63.2155 43.8674 63.2155 37.1726 59.0862 33.0434C54.957 28.9141 48.2622 28.9141 44.1329 33.0434C40.0037 37.1726 40.0037 43.8674 44.1329 47.9967C48.2622 52.1259 54.957 52.1259 59.0862 47.9967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8449 53.2547L29.7091 55.1188H18.9297V46.6919H16V58.0485H29.7091L27.8449 59.9128L29.9165 61.9844L35.3172 56.5837L29.9165 51.1831L27.8449 53.2547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_4357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalReferringdomains);
export default __webpack_public_path__ + "static/media/TotalReferringdomains.04e9e7fced7da9e310045b051e905e9b.svg";
export { ForwardRef as ReactComponent };